<script setup>
defineProps({
    type: {
        type: String,
        default: 'submit',
    },
});
</script>

<template>
    <button :type="type" class="relative items-center justify-center space-x-2 rounded-md border border-transparent bg-brand px-4 py-1.5 text-sm font-medium text-white hover:bg-brand-dark focus:outline-hidden focus:ring-1 disabled:cursor-not-allowed disabled:border-gray-200 disabled:bg-gray-50 disabled:text-gray-500">
        <slot />
    </button>
</template>
